import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import CircleButton from '../../components/CircleButton';
import HydrantModelRow from '../../components/hydrantModels/HydrantModelRow';
import { getHydrantModels, deleteHydrantModel } from '../../services/api';

const HydrantModels = () => {
  const [hydrantModels, setHydrantModels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setupHydrantModels();
  }, []);

  const setupHydrantModels = async () => {
    setLoading(true);
    const result = await getHydrantModels();
    const resultSorted = result.sort((a, b) => (a.modelId <= b.modelId ? -1 : 1));
    setHydrantModels(resultSorted);
    setLoading(false);
  };

  const onDelete = async id => {
    await deleteHydrantModel(id);
    await setupHydrantModels();
  };

  const rows = hydrantModels?.map((hydrantModel, index) => (
    <HydrantModelRow key={index} hydrantModel={hydrantModel} onDelete={onDelete} />
  ));

  return (
    <div id="hydrantModels" className="list">
      <h2>Hydrant Models</h2>
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Model ID</th>
              <th>Description</th>
              <th>Open Direction</th>
              <th>Valve Turns</th>
              <th>Barrel Type</th>
              <th className="command-row">
                <Link to={'hydrantModels/add'}>
                  <CircleButton icon={faPlus} type="success" title="Add Hydrant Model" />
                </Link>
              </th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default HydrantModels;
